import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import ParityManagerStat from 'lumen/models/parity-manager/stat';

export default class ParityManagerIssuestat extends ParityManagerStat {
  // @ts-expect-error: Class inheritance
  [Type] = 'parity-manager/issuestat' as const;

  @attr('number') declare amountIssues: number;
  @attr('string') declare name: string;
  @attr('number') declare numSubscriptions: number;
}
